import { useEffect, useState } from "react";
import { createGenericContext } from "../utils/createGenericContext";

export interface ISiteContext {
  modalVisible: boolean
  modalLoading: boolean
  modalContent: any
  showModal: (content: any, loading?: boolean) => void
  hideModal: () => void
}

const [useSite, SiteContextProvider] =
  createGenericContext<ISiteContext>();

const SiteProvider = ({ children }: any) => {
  const [modalVisible, setModalVisible] = useState(false)
  const [modalContent, setModalContent] = useState()
  const [modalLoading, setModalLoading] = useState(false)

  const showModal = (content: any, loading?: boolean) => {
    setModalContent(content)
    setModalVisible(true)
    setModalLoading(loading || false)
  }

  const hideModal = () => {
    setModalVisible(false)
  }

  let contextValue = {
    modalVisible,
    modalContent,
    showModal,
    hideModal,
    modalLoading
  };

  return (
    <SiteContextProvider value={contextValue}>
      {children}
    </SiteContextProvider>
  );
};

export { SiteProvider, useSite };
